var _defs, _path, _path2, _ellipse, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_9",
    width: 32.783,
    height: 30.488,
    viewBox: "0 0 32.783 30.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#414141}.cls-2,.cls-3{fill:none;stroke:#b8b8b8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.cls-2{stroke-width:1.5px}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    d: "M9.015 31.488h-.327C8.36 31.161 8.2 31 8.2 30.669V24.6H.82a.774.774 0 0 1-.82-.82V1.82A.774.774 0 0 1 .82 1h25.734a.6.6 0 0 1 .492.164l5.409 4.262c.164 0 .328.164.328.492v17.866a.774.774 0 0 1-.82.82H16.719l-7.212 6.721c-.164 0-.328.163-.492.163zm-7.376-8.523h7.376a.774.774 0 0 1 .82.82v5.081l6.065-5.573a.6.6 0 0 1 .492-.164h14.752V6.573L26.227 2.8 1.639 2.639z",
    className: "cls-1",
    "data-name": "Path 127",
    transform: "translate(0 -1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    d: "M5.978 13.057a3.278 3.278 0 1 1 3.279-3.279 3.187 3.187 0 0 1-3.279 3.279zm0-5.081a1.643 1.643 0 0 0-1.639 1.638 1.763 1.763 0 0 0 1.639 1.639 1.763 1.763 0 0 0 1.639-1.639 1.643 1.643 0 0 0-1.639-1.639z",
    className: "cls-1",
    "data-name": "Path 130",
    transform: "translate(1.726 2.515)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    cx: 3.278,
    cy: 3.278,
    className: "cls-1",
    "data-name": "Ellipse 5",
    rx: 3.278,
    ry: 3.278,
    transform: "translate(13.113 9.015)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    d: "M16.578 13.057a3.278 3.278 0 1 1 3.278-3.278 3.288 3.288 0 0 1-3.278 3.278zm0-5.081a1.643 1.643 0 0 0-1.639 1.639 1.763 1.763 0 0 0 1.639 1.639 1.763 1.763 0 0 0 1.639-1.639 1.643 1.643 0 0 0-1.639-1.64z",
    className: "cls-1",
    "data-name": "Path 131",
    transform: "translate(8.501 2.515)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.a159ddaabfd91aa9d1d8046bb7538f55.svg";
export { ForwardRef as ReactComponent };